import React, { useState } from 'react';
import { Layout, Menu, Avatar, Dropdown, Space, MenuProps } from 'antd';
import {
  DashboardOutlined,
  BankOutlined,
  ShopOutlined,
  BarChartOutlined,
  UserOutlined,
  LogoutOutlined,
} from '@ant-design/icons';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import './MainLayout.css';

const { Header, Sider, Content, Footer } = Layout;

type MenuItem = Required<MenuProps>['items'][number];

const MainLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useAuthStore((state) => state.user);
  const logout = useAuthStore((state) => state.logout);
  const [collapsed, setCollapsed] = useState(false);

  const menuItems: MenuItem[] = [
    {
      key: '/admin/dashboard',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
    },
    {
      key: '/admin/medical-facilities',
      icon: <BankOutlined />,
      label: 'Quản lý CSYT',
    },
    {
      key: '/admin/suppliers',
      icon: <ShopOutlined />,
      label: 'Quản lý nhà cung cấp',
    },
    {
      key: '/admin/statistics',
      icon: <BarChartOutlined />,
      label: 'Thống kê',
    },
    {
      key: '/admin/users',
      icon: <UserOutlined />,
      label: 'Quản lý user',
    },
  ];

  const handleMenuClick = ({ key }: { key: string }) => {
    navigate(key);
  };

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const userMenuItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Đăng xuất',
    },
  ];

  const handleUserMenuClick = ({ key }: { key: string }) => {
    if (key === 'logout') {
      handleLogout();
    }
  };

  return (
    <Layout className="medical-facility-layout">
      <Header className="medical-facility-header">
        <div className="header-left">
          <div className="logo-container">
            <div className="logo-icon-small">O</div>
            <span className="logo-text">OMECAP HUB - QUẢN LÝ CSYT</span>
          </div>
        </div>
        <div className="header-right">
          <Dropdown menu={{ items: userMenuItems, onClick: handleUserMenuClick }} placement="bottomRight">
            <Space className="user-info">
              <Avatar icon={<UserOutlined />} />
              <span>{user ? `${user.first_name} ${user.last_name}`.trim() || user.username : 'User'}</span>
            </Space>
          </Dropdown>
        </div>
      </Header>
      <Layout>
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={setCollapsed}
          width={250}
          className="medical-facility-sider"
        >
          <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            items={menuItems}
            onClick={handleMenuClick}
            className="medical-facility-menu"
          />
        </Sider>
        <Layout>
          <Content className="medical-facility-content">
            <Outlet />
          </Content>
          <Footer className="medical-facility-footer">
            Copyright Omecap © 2025
          </Footer>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default MainLayout;